var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNetworkMap(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 63,
    viewBox: "0 0 63 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.75 34.0833C23.75 39.7903 28.3764 44.4167 34.0833 44.4167C36.9368 44.4167 39.5201 43.2601 41.3901 41.3901M23.75 34.0833H13.4167M23.75 34.0833C23.75 30.074 26.0334 26.598 29.3706 24.8848M13.4167 34.0833C13.4167 35.5101 12.2601 36.6667 10.8333 36.6667C9.4066 36.6667 8.25 35.5101 8.25 34.0833C8.25 32.6566 9.4066 31.5 10.8333 31.5C12.2601 31.5 13.4167 32.6566 13.4167 34.0833ZM50.34 17.8267C49.8725 17.3592 49.5833 16.7134 49.5833 16C49.5833 14.5733 50.7399 13.4167 52.1667 13.4167C53.5934 13.4167 54.75 14.5733 54.75 16C54.75 17.4267 53.5934 18.5833 52.1667 18.5833C51.4533 18.5833 50.8075 18.2942 50.34 17.8267ZM50.34 17.8267L41.3901 26.7766M24.7097 13.2325C25.6612 12.8516 26.3333 11.9209 26.3333 10.8333C26.3333 9.4066 25.1767 8.25 23.75 8.25C22.3233 8.25 21.1667 9.4066 21.1667 10.8333C21.1667 12.2601 22.3233 13.4167 23.75 13.4167C24.0891 13.4167 24.413 13.3513 24.7097 13.2325ZM24.7097 13.2325L29.3706 24.8848M41.3901 41.3901C43.2601 39.5201 44.4167 36.9368 44.4167 34.0833C44.4167 31.2299 43.2601 28.6465 41.3901 26.7766M41.3901 41.3901L50.34 50.34M50.34 50.34C49.8725 50.8075 49.5833 51.4533 49.5833 52.1667C49.5833 53.5934 50.7399 54.75 52.1667 54.75C53.5934 54.75 54.75 53.5934 54.75 52.1667C54.75 50.7399 53.5934 49.5833 52.1667 49.5833C51.4533 49.5833 50.8075 49.8725 50.34 50.34ZM41.3901 26.7766C39.5201 24.9066 36.9368 23.75 34.0833 23.75C32.3857 23.75 30.7837 24.1594 29.3706 24.8848",
    stroke: "url(#paint0_linear_7323_23440)",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7323_23440",
    x1: 8.25,
    y1: 31.5,
    x2: 54.75,
    y2: 31.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#992FDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D73FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetworkMap);
export default __webpack_public_path__ + "static/media/networkMap.931d6c68b41e97332aad21515a716253.svg";
export { ForwardRef as ReactComponent };